(function () {
  // this function was copied from side-cart.js, which copied it from cart-notification.js
  function renderCartBubble(item_count = 0) {
    const cartBubbleContainer = document.querySelector("#cart-icon-bubble");
    if (cartBubbleContainer.querySelector(".cart-count-bubble")) {
      cartBubbleContainer.querySelector(".cart-count-bubble").remove();
    }
    if (item_count > 0) {
      let cartBubble = document.createElement("div");
      cartBubble.className = "cart-count-bubble";
      cartBubble.innerHTML = `
      <span aria-hidden="true">${item_count}</span>
      <span class="visually-hidden">${item_count} item</span>
    `;
      cartBubbleContainer.append(cartBubble);
    }
  }

  document.addEventListener("rebuy:cart.change", (event) => {
    const cart = event.detail.cart.cart;

    // update the visual quantity in the cart bubble
    renderCartBubble(cart.item_count);
  });
})();
